import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { InboxNavigationService } from '@galaxy/conversation/core';
import { FeatureFlagService } from '@galaxy/partner';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { PARTNER_ID } from '../../tokens';
import { FeatureFlags } from '../feature-flags';

@Injectable()
export class InboxRoutingGuard {
  constructor(
    @Inject(PARTNER_ID) private partnerId$: Observable<string>,
    private featureFlagService: FeatureFlagService,
    private router: Router,
    private inboxNav: InboxNavigationService,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<boolean> {
    return this.partnerId$.pipe(
      take(1),
      switchMap((partnerId) => {
        return this.featureFlagService.batchGetStatus(partnerId, 'default', [FeatureFlags.INBOX_TAB_PCC]);
      }),
      map((featureFlags) => {
        this.router.navigate(['/products'], { queryParamsHandling: 'preserve' }).then(() => {
          if (featureFlags[FeatureFlags.INBOX_TAB_PCC]) {
            this.inboxNav.gotoConversationID(route.params['id']);
          }
        });
        return false;
      }),
    );
  }
}
